/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface BulkDestroyDocumentsRequest
 */
export interface BulkDestroyDocumentsRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof BulkDestroyDocumentsRequest
   */
  ids: Array<string>
}

export function BulkDestroyDocumentsRequestFromJSON(json: any): BulkDestroyDocumentsRequest {
  return BulkDestroyDocumentsRequestFromJSONTyped(json, false)
}

export function BulkDestroyDocumentsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkDestroyDocumentsRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    ids: json['ids']
  }
}

export function BulkDestroyDocumentsRequestToJSON(value?: BulkDestroyDocumentsRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    ids: value.ids
  }
}
